import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import LegalDraftNotice from '@/components/LegalDraftNotice';
import { useLegalDraftStatus } from '@/config/legalStatus';

const PrivacyPolicyPage = () => {
  const isDraftLegal = useLegalDraftStatus();
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-b from-primary/5 to-transparent">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto"
      >
        <Link to="/" className="inline-flex items-center gap-2 mb-8 text-muted-foreground hover:text-foreground transition-colors" data-testid="privacy-back-link">
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>

        <div className="bg-card text-card-foreground rounded-2xl border border-border/50 shadow-lg p-8" data-testid="privacy-policy-page">
          <LegalDraftNotice docName="Privacy Policy" />
          <div className="flex items-center gap-3 mb-6">
            <ShieldCheck className="w-8 h-8 text-primary" />
            <div>
              <h1 className="text-3xl font-bold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>Privacy Policy</h1>
              <p className="text-sm text-muted-foreground" data-testid="privacy-policy-version">
                {isDraftLegal !== false ? 'Draft — not yet in effect' : <>Version 1.0 &middot; Effective 18 August 2026</>}
              </p>
            </div>
          </div>

          <div className="space-y-4 text-base text-foreground/90 leading-relaxed">
            <p>INSUL NUTRIENTS collects the information you provide (email, profile details, meal photos and nutrition logs) solely to deliver your visual food diary and nutrition programs.</p>
            <p>Meal photos are retained for a maximum of 7 days, after which the image is permanently deleted while your nutrition history is kept.</p>
            <p>You may request deletion of your account and all associated data at any time.</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicyPage;
